module.exports = __webpack_public_path__ + "static/media/048-dental irrigator.553837c9.svg";